export default {
  title: "SIMPEG TIRTA HITA"
};
